import { alertShipmentTypes} from "../actions/alertsShipment";

const initialState = {
  isLoading: false,
  isDownloaded: "",
  filters: {
    isLoaded: false,
    status: [],
    level: "",
    subject: "",
    lastUpdated: "",
    shipmentid:"",
    sort: [
      {
        field: "createdon",
        order: "desc",
      },
    ],
    pagenumber: 0,
    limitnumber: 10,
  },
  data: {
    statuses: [
      {
        text: "New",
        value: true,
      },
      {
        text: "Acknowledged",
        value: false,
      },
      {
        text: "Resolved",
        value: false,
      },
      {
        text: "Auto Resolved",
        value: false,
      },
    ],
    status: [
      {
        text: "New",
        value: false,
      },
      {
        text: "Acknowledged",
        value: false,
      },
      {
        text: "Resolved",
        value: false,
      },
      {
        text: "Auto Resolved",
        value: false,
      },
    ],
    level: [
      {
        label: "Warning",
        value: false,
      },
      {
        label: "Critical",
        value: false,
      },
      {
        label: "Notification",
        value: false,
      },
    ],
    alerts: [],
    devices: [],
  },
  bulkUpdate: {
    statuses: [
      {
        label: "All",
        value: "",
      },
      {
        label: "New",
        value: "new",
      },
      {
        label: "Acknowledged",
        value: "acknowledged",
      },
      {
        label: "Resolved",
        value: "resolved",
      },
    ],
    isFiltered: false,
    isUpdating: false,
    isFiltering: false,
    filters: {
      fields: {
        subject: "",
        status: { new: false, acknowledged: false, resolved: false },
        lastUpdated: "",
      },
      count: 0,
    },
    fields: {
      status: "",
    },
  },
  singleUpdate: {
    isUpdating: false,
    currentData: {},
    fields: {
      status: "",
    },
  },
  notification: {
    isActive: false,
    type: "success",
    message: "",
    description: "",
    style: { backgroundColor: "#d4edda", color: "#155724" },
  },
  alertCounts: {
    total: 0,
    warning: 0,
    error: 0,
  },
  error: null,
};

const alertShipmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case alertShipmentTypes.FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case alertShipmentTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          ...action.payload.list,
        },
        filters: {
          ...state.filters,
          isLoaded: true,
        },
        bulkUpdate: {
          ...state.bulkUpdate,
        },
        error: null,
      };
    case alertShipmentTypes.UPDATE_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
          sort: action.payload.sort,
        },
      };
    case alertShipmentTypes.ALERT_COUNT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        alertCounts: action.payload,
      };
    case alertShipmentTypes.FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        data: {
          ...state.data,
          alerts: [],
        },
        alertCounts: {
          total: 0,
          warning: 0,
          error: 0,
        },
        error: action.payload,
      };
    case alertShipmentTypes.BULK_UPDATE_FILTER_FIELD:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          filters: {
            ...state.bulkUpdate.filters,
            fields: {
              ...state.bulkUpdate.filters.fields,
              ...action.payload,
            },
          },
        },
      };
    case alertShipmentTypes.BULK_UPDATE_FIELD:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          fields: {
            ...state.bulkUpdate.fields,
            ...action.payload,
          },
        },
      };
    case alertShipmentTypes.BULK_UPDATE_FILTER:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          isFiltered: action.payload,
          isFiltering: true,
        },
      };
    case alertShipmentTypes.BULK_UPDATE_FILTER_BACK:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          isFiltered: false,
        },
      };
    case alertShipmentTypes.BULK_UPDATE_FILTER_SUCCESS:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          isFiltering: false,
          filters: {
            ...state.bulkUpdate.filters,
            count: action.payload,
          },
        },
      };
    case alertShipmentTypes.BULK_UPDATE_FILTER_FAILURE:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          isFiltering: false,
          filters: {
            ...state.bulkUpdate.filters,
            count: 0,
          },
        },
      };
    case alertShipmentTypes.BULK_UPDATE_SUBMIT:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          isUpdating: true,
        },
      };
    case alertShipmentTypes.BULK_UPDATE_RESPONSE:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          isFiltered: false,
          isUpdating: false,
          filters: {
            fields: {
              subject: "",
              status: { new: false, acknowledged: false, resolved: false },
              lastUpdated: "",
            },
            count: 0,
          },
          fields: {
            status: "",
          },
        },
        notification: {
          ...state.notification,
          ...action.payload,
        },
      };
    case alertShipmentTypes.SINGLE_UPDATE_REQUEST:
      return {
        ...state,
        singleUpdate: {
          ...state.singleUpdate,
          currentData: action.payload.current,
          fields: action.payload.fields,
        },
      };
    case alertShipmentTypes.SINGLE_UPDATE_SUBMIT:
      return {
        ...state,
        singleUpdate: {
          ...state.singleUpdate,
          isUpdating: true,
        },
      };
    case alertShipmentTypes.SINGLE_UPDATE_FIELD:
      return {
        ...state,
        singleUpdate: {
          ...state.singleUpdate,
          fields: {
            ...state.singleUpdate.fields,
            ...action.payload,
          },
        },
      };
    case alertShipmentTypes.SINGLE_UPDATE_RESPONSE:
      return {
        ...state,
        singleUpdate: {
          ...state.singleUpdate,
          isUpdating: false,
          currentData: {},
          fields: {
            status: "",
          },
        },
        notification: {
          ...state.notification,
          ...action.payload,
        },
      };
    case alertShipmentTypes.DOWNLOAD_REQUEST:
      return {
        ...state,
        isDownloaded: "Downloading....",
      };
    case alertShipmentTypes.DOWNLOAD_SUCCESS:
      return {
        ...state,
        isDownloaded: "Downloaded",
      };
    case alertShipmentTypes.DOWNLOAD_FAILURE:
      return {
        ...state,
        isDownloaded: "Something Went Wrong",
        error: action.payload,
      };
    case "RESET_BULK_UPDATE_FORM":
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          isFiltered: false,
          isFiltering: false,
          filters: {
            fields: {
              subject: "",
              status: {},
            },
            count: 0,
          },
          fields: {
            status: "",
          },
        },
      };
    default:
      return state;
  }
};

export default alertShipmentReducer;
